import { BaseResponse } from './base.response';
import { Owner } from '../models';

export class OwnerResponse extends BaseResponse {

    public owners: Owner[];
    
}